import { render, staticRenderFns } from "./AttrImage.vue?vue&type=template&id=f65c9d00&scoped=true"
import script from "./AttrImage.vue?vue&type=script&lang=js"
export * from "./AttrImage.vue?vue&type=script&lang=js"
import style0 from "./AttrImage.vue?vue&type=style&index=0&id=f65c9d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65c9d00",
  null
  
)

export default component.exports